import SEO from '../components/SEO';
import usePage from '../hooks/usePage';

const DEFAULT_CONTENT = "<p>Public Notice: 03-04-2024</p><ol><li>Click Here to View Public Notice regarding upgradation from primary school to senior Secondary School</li><li>Click Here to View the Previous Building plan</li><li>Click Here to View the Revised Building Plan</li></ol><p><strong>Note:</strong> There is no change in the previous and revised building plan.</p><p><strong>Contact Us</strong></p><p>WhatsApp<br /><a href=\"mailto:info@standrewsworldschool.com\">info@standrewsworldschool.com</a><br /><a href=\"tel:+919311668860\">+91-9311668860</a>, <a href=\"tel:+919311668861\">+91-9311668861</a><br />Visit our school address for more information</p>";

const PublicNotice = () => {
  const pageData = usePage('public-notice', { content: DEFAULT_CONTENT });

  const title = 'Public Notice';

  return (
    <>
      <SEO
        slug="public-notice"
        title={title} description="Public Notice - St. Andrews World School, Indirapuram. View official notices and announcements." keywords="Public Notice, SAWS Indirapuram" />

      <section className="page-hero">
        {!pageData.loading && <img src={pageData.bannerImage || '${process.env.PUBLIC_URL}/images/page-banners/why-choose-us.jpg'} alt={title} className="page-hero-img" loading="eager" />}
        <div className="page-hero-content">
          <div className="container">
            <div className="page-hero-inner"></div>
          </div>
        </div>
      </section>

      <section className="content-page">
        <div className="container">
          <div className="card p-7 md:p-10 max-w-[800px] mx-auto">
            <h1 className="text-[28px] md:text-[32px] text-primary font-display mb-6">Public Notice</h1>
            <div className="text-body leading-relaxed space-y-4" dangerouslySetInnerHTML={{ __html: pageData.content || DEFAULT_CONTENT }} />
          </div>
        </div>
      </section>
    </>
  );
};

export default PublicNotice;
